import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { PageStyle } from "@insite/mobius/Page";
import { PageLayoutWrapper } from "@store/Overrides/PageLayout";
import { clearfixStyles, lazyLoadKeyframes } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    css: css`
        html {
            overflow-x: hidden;
        }

        #react-app {
            > div:first-child {
                min-height: 100vh;
                display: flex;
                flex-direction: column;
                width: 100%;
                height: 100%;

                > ${PageLayoutWrapper} {
                    > ${PageStyle} {
                        overflow: inherit;
                    }
                }

                footer {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    justify-content: flex-end;
                }
            }
        }

        ${GridWrapper} {
            ${clearfixStyles()}
            max-width: none;
        }

        ${GridItemStyle} {
            overflow-wrap: normal;
            word-wrap: normal;
            -ms-word-break: normal;
            word-break: normal;
        }

        ${lazyLoadKeyframes()}
    `,
};
